import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,

  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    descuentos: [],
    descuento: [],
    descuentojuanas: 0,
    descuentopiels: 0,
    id: null,
    idusuario: null

  },
  mutations: {

    LoadProductos(state, buscar) {
      //let aux = [];
      state.descuento = state.descuentos;

      let aux = state.descuentos.filter((x) => x["idusuario"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.descuento = state.descuentos;
      } else {
        state.descuento = aux;


      }
    },



    async cargardatosdescuentos(state) {

      state.descuentos = []
      var token = store.state.numero;
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/descuentos", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.descuentos = response.data.data;


        }).catch((e) => {
          console.log(e);
          location.reload();
        });
      state.descuento = state.descuentos
    },

    cambio(state, descripcion) {

      state.descuentopiels = descripcion.descuentopiel
      state.descuentojuanas = descripcion.descuentojuana
      state.id = descripcion.id
      state.idusuario = store.state.user

    },
    agregartable(state) {

      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        descuentojuana: state.descuentojuanas,
        descuentopiel: state.descuentopiels,
        id: state.id,
        idusuario: state.idusuario
      };
      this.banderamodal = store.state.banderamodal



      var datosfalso = state.id

      if (this.banderamodal === true) {


        axios

          .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/descuentos", datos, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;


          })

          .catch((e) => {
            console.log(e);
            location.reload();
          });
      } else {

        axios

          .post(
            "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/descuentos/UpdateReg/" +
            datosfalso,
            datos,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;

          })

          .catch((e) => {
            console.log(e);
          });
      }

    },


    datosmodal(state, api) {

      state.descuentojuanas = api.descuentojuana,
        state.descuentopiels = api.descuentopiel,
        state.id = api.id,
        state.idusuario = api.idusuario


    },



    eliminar(state, api) {
      var token = store.state.numero
      let eliminar = api;

      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/descuentos/DeleteReg/" + eliminar,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })


        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;

          //this.bandera = true;
        })

        .catch((e) => {
          console.log(e);
        });



    },



  },
  actions: {

  },
  getters: {


  },






}